import React from 'react';
import pt from 'prop-types';

import Button from 'components/button';
import Link from 'components/link';
import { Form, Field } from 'components/form';

import './signup.scss';

const RESEND_COOLDOWN = 5000;

export default class SignupVerifyCode extends React.PureComponent {
  static propTypes = {
    defaultCode: pt.string,
    onSubmitCode: pt.func.isRequired,
    onResendEmail: pt.func,
  };

  sent = false;

  onClickResend = (event) => {
    event.preventDefault();

    if (this.sent) {
      return;
    }

    this.sent = true;
    setTimeout(() => {
      this.sent = false;
    }, RESEND_COOLDOWN);

    this.props.onResendEmail();
  };

  render() {
    const { defaultCode, onSubmitCode } = this.props;

    return (
      <div>
        <div className="signup-header">
          <h1 className="signup-title">We need to verify your email</h1>
          <div className="signup-subtitle">
            Copy the verification code to verify your email
          </div>
        </div>

        <Form onSubmit={onSubmitCode} autoFocus={true}>
          <Field
            type="text"
            name="code"
            label="Verification code"
            rules="required"
            defaultValue={defaultCode}
            large={true}
            validateIcon={true}
            validateBlur={true}
            showError={false}
            className="login-form-field-margin-24"
          />

          <div className="signup-actions">
            <Button size="large" type="submit" className="signup-submit">
              Verify my email
            </Button>

            <Link className="signup-back" onClick={this.onClickResend}>
              Resend verification code
            </Link>
          </div>
        </Form>
      </div>
    );
  }
}
